<template>
  <div class="markdown-stream" :style="customStyle">
    <div class="md-render" v-html="renderedHtml"></div>
    <span v-if="showCursor && !isFinish" class="cursor">|</span>
  </div>
</template>

<script>
import axios from 'axios'
import * as marked from 'marked'
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'

//配置 marked + 代码高亮
marked.setOptions({
  highlight: function (code) {
    return hljs.highlightAuto(code).value
  },
  breaks: true,
  gfm: true
})

export default {
  name: 'MarkdownStreamTypewriter',
  props: {
    data: { type: Object, default: () => ({}) },
    speed: { type: Number, default: 50 },    // 打字速度
    showCursor: { type: Boolean, default: true },
    customStyle: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      fullText: '',       // 完整接收的文本
      showText: '',       // 逐字显示的文本
      typeTimer: null,
      isFinish: false     // 流是否结束
    }
  },
  computed: {
    renderedHtml() {
      return  marked.parse(this.showText)
    }
  },
  mounted() {
    this.startStream()
    this.startType()
  },
  beforeDestroy() {
    clearInterval(this.typeTimer)
  },
  methods: {
    // 1. 流式接收后端返回
    async startStream() {
      try {
        await axios({
          method: 'post',
          url: (process.env["VUE_APP_BASE_URL"] || '/') + 'api' +'/idsp-pc/api/python/stream',
          data: this.data,
          responseType: 'text',
          onDownloadProgress: (e) => {
            const res = e.target.response || ''
            this.fullText = res
          }
        })
        // 标记结束
        setTimeout(() => {
          this.isFinish = true
        }, this.speed * 20)
      } catch (err) {
        console.error('流式请求失败', err)
      }
    },

    // 2. 逐字打印机效果
    startType() {
      this.typeTimer = setInterval(() => {
        if (this.showText.length < this.fullText.length) {
          this.showText = this.fullText.slice(0, this.showText.length + 1)
        }
      }, this.speed)
    }
  }
}
</script>

<style scoped>
.markdown-stream {
  font-size: 15px;
  line-height: 1.7;
}
.md-render {
  color: #333;
}
.md-render >>> p {
  margin: 0.6em 0;
}
.md-render >>> h1,
.md-render >>> h2,
.md-render >>> h3 {
  margin: 1em 0 0.5em;
  font-weight: bold;
}
.md-render >>> ul,
.md-render >>> ol {
  padding-left: 1.5em;
}
.md-render >>> pre {
  background: #f6f8fa;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
}
.md-render >>> code {
  background: #f6f8fa;
  padding: 2px 4px;
  border-radius: 3px;
}
.cursor {
  animation: blink 1s step-end infinite;
  margin-left: 2px;
  font-weight: bold;
}
@keyframes blink {
  50% { opacity: 0; }
}
</style>
